import { combineReducers } from '@reduxjs/toolkit';
import { dealsReducer } from './deals/deals.slice';
import { creditsDistributionPoolsReducer } from './creditPool';

export const creditsDistributionReducer = combineReducers({
  deals: dealsReducer,
  creditPools: creditsDistributionPoolsReducer
});
